export default __webpack_public_path__ + "static/media/design.ba322448.svg";